// import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
// import styles from "./GoogleAddressInputWithDropdown.module.css"
// const GoogleAddressInputWithDropdown = forwardRef(
//     ({ value, onChange, placeholder = "Enter address", maxLength = 300, scrollIntoView, listPosition = "absolute", listPaddingRight = "25px" ,listMarginTop = "10px" }, ref) => {
//         const [address, setAddress] = useState(value || "");
//         const [suggestions, setSuggestions] = useState([]);
//         const [showDropdown, setShowDropdown] = useState(false);
//         const inputRef = useRef(null);
//         const isIphone = /iPhone|iPod/i.test(navigator.userAgent);
//         // Expose methods to parent via ref
//         useImperativeHandle(ref, () => ({
//             getValue: () => address,
//             setValue: (val) => setAddress(val),
//         }));

//         const handleChange = (val) => {
//             setAddress(val);
//             onChange?.(val);

//             if (val.length > 2 && window.google?.maps?.places) {
//                 const service = new window.google.maps.places.AutocompleteService();
//                 service.getPlacePredictions(
//                     { input: val, types: ["geocode"] },
//                     (predictions, status) => {
//                         if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
//                             setSuggestions(predictions);
//                             setShowDropdown(true);
//                         } else {
//                             setSuggestions([]);
//                             setShowDropdown(false);
//                         }
//                     }
//                 );
//             } else {
//                 setSuggestions([]);
//                 setShowDropdown(false);
//             }
//         };

//         const handleSelectSuggestion = (suggestion) => {
//             setAddress(suggestion.description);
//             onChange?.(suggestion.description);
//             setShowDropdown(false);
//         };

//         const handleFocusOrClick = () => {
//             if (!isIphone && scrollIntoView) {
//                 setTimeout(scrollIntoView, 300);
//             }
//         };

//         // Close dropdown if clicked outside
//         useEffect(() => {
//             const handleClickOutside = (e) => {
//                 if (inputRef.current && !inputRef.current.contains(e.target)) {
//                     setShowDropdown(false);
//                 }
//             };
//             document.addEventListener("mousedown", handleClickOutside);
//             return () => document.removeEventListener("mousedown", handleClickOutside);
//         }, []);
//         useEffect(() => {
//             setAddress(value || "");
//         }, [value]);
//         return (
//             <>
//                 <input
//                     type="text"
//                     value={address}
//                     onChange={(e) => handleChange(e.target.value)}
//                     placeholder={placeholder}
//                     required
//                     maxLength={maxLength}
//                     onFocus={handleFocusOrClick}
//                     onClick={handleFocusOrClick}
//                     autoComplete="off"
//                 />
//                 {showDropdown && suggestions.length > 0 && (
//                     <ul className={styles.listdiv}
//                         style={{
//                             position: listPosition,
//                             paddingRight: listPaddingRight,
//                              marginTop: listMarginTop
//                         }} >

//                         <div className={styles.dropdown}>
//                             {suggestions.map((sug, i) => (
//                                 <div
//                                     key={i}
//                                     className={styles.option}
//                                     onMouseDown={(e) => e.preventDefault()}
//                                     onClick={() => handleSelectSuggestion(sug)}
//                                 >
//                                     <div className={styles.icon}><img src="/svg/location-new.svg" alt="location-new.svg" /></div>

//                                     <div>
//                                         <div className={styles.title}>
//                                             {sug.description}
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}

//                             <div className={styles.powered}>
//                                 Powered by <span className={styles.brand}><img src="/svg/powered-rexpt-logo.svg" alt="powered-rexpt-logo" /></span>
//                             </div>
//                         </div>
//                     </ul>
//                 )}
//             </>
//         );
//     }
// );

// export default GoogleAddressInputWithDropdown;


import React, { useEffect, useLayoutEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import styles from "./GoogleAddressInputWithDropdown.module.css"
// Address suggestions us country tak seemit rehni chahiye jahan se number
// khareeda ja sakta hai. India site pe "delhi" likhne par warna Delhi NY /
// Delhi CA aate hain, aur un me se kisi ka number Vobiz ke paas hai hi nahi.
import { supportedNumberCountries } from "../../utils/apiBackend";

const GoogleAddressInputWithDropdown = forwardRef(
    ({ value, onChange, placeholder = "Enter address", maxLength = 300, scrollIntoView, listPosition = "absolute", listPaddingRight = "25px", listMarginTop = "10px", inputClassName, multiline = false }, ref) => {
        const [address, setAddress] = useState(value || "");
        const [suggestions, setSuggestions] = useState([]);
        const [showDropdown, setShowDropdown] = useState(false);
        const [highlightedIndex, setHighlightedIndex] = useState(-1); // ← NEW
        const inputRef = useRef(null);
        // multiline: a textarea that grows with the text, so a long address
        // wraps instead of being cut off on narrow (phone) screens.
        const fieldRef = useRef(null);
        useLayoutEffect(() => {
            const el = fieldRef.current;
            if (!multiline || !el) return;
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
        }, [address, multiline]);
        const dropdownListRef = useRef(null); // ← NEW: scroll ke liye
        const isIphone = /iPhone|iPod/i.test(navigator.userAgent);

        // Expose methods to parent via ref
        useImperativeHandle(ref, () => ({
            getValue: () => address,
            setValue: (val) => setAddress(val),
            // Focus the inner input (opens the suggestions dropdown via its
            // onFocus handler) — used by the pencil/edit affordance.
            focus: () => {
                const el = inputRef.current?.querySelector("input");
                if (el) el.focus();
            },
        }));

        const handleChange = (val) => {
            setAddress(val);
            onChange?.(val);
            setHighlightedIndex(-1); // ← reset on type

            if (val.length > 2 && window.google?.maps?.places) {
                const service = new window.google.maps.places.AutocompleteService();
                service.getPlacePredictions(
                    // Countries this site can actually sell a number in — India site gives
                    // ["IN"], everything else ["US","CA"]. Google wants lowercase ISO codes.
                    {
                        input: val,
                        types: ["geocode"],
                        componentRestrictions: {
                            country: supportedNumberCountries().map((c) => c.toLowerCase()),
                        },
                    },
                    (predictions, status) => {
                        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
                            setSuggestions(predictions);
                            setShowDropdown(true);
                        } else {
                            setSuggestions([]);
                            setShowDropdown(false);
                        }
                    }
                );
            } else {
                setSuggestions([]);
                setShowDropdown(false);
            }
        };

        const handleSelectSuggestion = (suggestion) => {
            setAddress(suggestion.description);
            onChange?.(suggestion.description, suggestion.place_id); // ← place_id bhi pass
            setShowDropdown(false);
            setHighlightedIndex(-1); // ← reset
        };

        // ── NEW: highlighted item ko view mein scroll karo ──────
        const scrollOptionIntoView = (index) => {
            if (dropdownListRef.current) {
                const item = dropdownListRef.current.children[index];
                item?.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
        };

        // ── NEW: Keyboard handler ────────────────────────────────
        const handleKeyDown = (e) => {
            // An address is one line even when it wraps.
            if (multiline && e.key === "Enter") e.preventDefault();
            if (!showDropdown || suggestions.length === 0) return;

            switch (e.key) {
                case "ArrowDown":
                    e.preventDefault();
                    setHighlightedIndex(prev => {
                        const next = prev < suggestions.length - 1 ? prev + 1 : 0;
                        scrollOptionIntoView(next);
                        return next;
                    });
                    break;

                case "ArrowUp":
                    e.preventDefault();
                    setHighlightedIndex(prev => {
                        const next = prev > 0 ? prev - 1 : suggestions.length - 1;
                        scrollOptionIntoView(next);
                        return next;
                    });
                    break;

                case "Enter":
                    e.preventDefault();
                    if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
                        handleSelectSuggestion(suggestions[highlightedIndex]);
                    }
                    break;

                case "Tab":
                    // Tab se highlighted item select karo, phir next field pe focus jaye
                    if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
                        e.preventDefault();
                        handleSelectSuggestion(suggestions[highlightedIndex]);
                    } else {
                        setShowDropdown(false);
                        setHighlightedIndex(-1);
                    }
                    break;

                case "Escape":
                    setShowDropdown(false);
                    setHighlightedIndex(-1);
                    break;

                default:
                    break;
            }
        };
        // ────────────────────────────────────────────────────────

        const handleFocusOrClick = () => {
            if (!isIphone && scrollIntoView) {
                setTimeout(scrollIntoView, 300);
            }
        };

        // Close dropdown if clicked outside
        useEffect(() => {
            const handleClickOutside = (e) => {
                if (inputRef.current && !inputRef.current.contains(e.target)) {
                    setShowDropdown(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }, []);

        useEffect(() => {
            setAddress(value || "");
        }, [value]);

        return (
            <div ref={inputRef}> {/* ← wrapper: outside click ke liye */}
                {React.createElement(multiline ? "textarea" : "input", {
                    ...(multiline ? { rows: 1 } : { type: "text" }),
                    ref: fieldRef,
                    className: inputClassName,
                    value: address,
                    onChange: (e) => handleChange(e.target.value.replace(/\n/g, " ")),
                    onKeyDown: handleKeyDown,
                    placeholder,
                    required: true,
                    maxLength,
                    onFocus: handleFocusOrClick,
                    onClick: handleFocusOrClick,
                    autoComplete: "off",
                })}
                {showDropdown && suggestions.length > 0 && (
                    <ul className={styles.listdiv}
                        style={{
                            position: listPosition,
                            paddingRight: listPaddingRight,
                            marginTop: listMarginTop
                        }}>

                        <div className={styles.dropdown} ref={dropdownListRef}> {/* ← scroll ref */}
                            {suggestions.map((sug, i) => (
                                <div
                                    key={i}
                                    className={`${styles.option} ${highlightedIndex === i ? styles.highlighted : ""}`} // ← highlighted class
                                    onMouseDown={(e) => e.preventDefault()} // ← blur rokne ke liye
                                    onClick={() => handleSelectSuggestion(sug)}
                                    onMouseEnter={() => setHighlightedIndex(i)} // ← mouse hover pe index sync
                                >
                                    <div className={styles.icon}><img src="/svg/location-new.svg" alt="location-new.svg" /></div>

                                    <div>
                                        <div className={styles.title}>
                                            {sug.description}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className={styles.powered}>
                                Powered by <span className={styles.brand}><img src="/svg/powered-rexpt-logo.svg" alt="powered-rexpt-logo" /></span>
                            </div>
                        </div>
                    </ul>
                )}
            </div>
        );
    }
);

export default GoogleAddressInputWithDropdown;